import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Document, Page, pdfjs } from 'react-pdf';
import { Button, Typography } from 'antd';
import { DownloadOutlined, LeftOutlined } from '@ant-design/icons';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const { Title } = Typography;

const PDFPage = () => {
  const [searchParams] = useSearchParams();
  const pdfUrl = searchParams.get('url');
  const title = searchParams.get('title');
  const downloadable = searchParams.get('downloadable') === 'true';
  const from = searchParams.get('from');
  const [numPages, setNumPages] = useState(null);
  const [pdfWidth, setPdfWidth] = useState(Math.min(window.innerWidth - 32, 800));

  useEffect(() => {
    const handleResize = () => {
      setPdfWidth(Math.min(window.innerWidth - 32, 800));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getBackPath = () => {
    switch(from) {
      case 'information':
        return '/resources/information';
      case 'advice':
        return '/resources/advice';
      case 'resource':
        return '/resources/resource';
      case 'guidance':
        return '/resources/guidance';
      default:
        return '/resources';
    }
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = `${title}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="min-h-screen ">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between mb-4 mt-4">
          <Link to={getBackPath()} className="flex items-center text-blue-500 hover:text-blue-700">
            <LeftOutlined className="mr-2" />
            Back
          </Link>
          {downloadable && (
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={handleDownload}
            >
              Download PDF
            </Button>
          )}
        </div>
        <Title level={2} className="mb-24">
          {title}
        </Title>

        <div className="flex flex-col items-center pt-8">
          <Document
            file={pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<div className="text-gray-500 text-lg">Loading ...</div>}
            error={<div className="text-red-500 text-lg">Error loading PDF. Please try again.</div>}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                loading={<div className="text-gray-500">Loading page...</div>}
                className="shadow-lg mb-4"
                renderTextLayer={false}
                renderAnnotationLayer={false}
                width={pdfWidth}
                scale={1}
              />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
};

export default PDFPage;
